import React, { memo } from 'react';
import { connect } from 'react-redux';
import { List } from 'immutable';

import Popup from 'src/components/helpers/Popup';
import { EmailTemplateSendGridForm } from 'src/components/EmailTemplateSendGridManagement/EmailTemplateSendGridForm';
import { createEmailTemplateSendGrid, handleUpdateForm } from 'src/actions/emailTemplatesSendGrid';

import { Footer } from './Footer';
import { usePopupContext } from '../../../contexts/PopupContext';

const AddEmailTemplateSendGridPopupComponent = ({
  activities,
  emailTemplate,
  createEmailTemplateSendGrid,
  handleUpdateForm,
}) => {
  const { closePopup, openPopup, onClosePopup } = usePopupContext();
  const activity = emailTemplate.getIn(['activity', 'selected', 'value']);
  const buyerId = emailTemplate.getIn(['buyer', 'buyer', 'selected', 'id']);
  const projectId = emailTemplate.getIn(['buyer', 'project', 'selected', 'id']);
  const templateName = emailTemplate.getIn(['templateName', 'value']);
  const file = emailTemplate.get('file') ? emailTemplate.get('file') : undefined;
  const htmlSource = emailTemplate.get('htmlSource') ? emailTemplate.get('htmlSource') : undefined;
  const subject = emailTemplate.getIn(['subject', 'value']);
  const fromName = emailTemplate.getIn(['fromName', 'value']);
  const fromEmail = emailTemplate.getIn(['fromEmail', 'value']);

  const handleSave = () => {
    createEmailTemplateSendGrid({
      activity,
      buyerId,
      projectId,
      templateName,
      file,
      htmlSource,
      subject,
      fromName,
      fromEmail,
    });
    closePopup();
  };

  const handleUpdateHtmlSource = data => {
    handleUpdateForm({
      name: 'newTemplate',
      ...data,
    });
  };

  const handleOpenEditor = () => {
    openPopup('TemplateEditorPopup', { htmlSource, onSave: handleUpdateHtmlSource });
    onClosePopup(() => {
      openPopup('AddEmailTemplateSendGridPopup');
    });
  };

  const handleUploadFile = event => {
    handleUpdateForm({
      name: 'newTemplate',
      formName: 'file',
      formData: event.target.files.item(0),
    });
  };

  const isDisabledSave = !(activity && buyerId && projectId && templateName && (file || htmlSource));

  const footer = (
    <Footer
      isDisabledSave={isDisabledSave}
      onOpenEditor={handleOpenEditor}
      onSave={handleSave}
      onUploadFile={handleUploadFile}
    />
  );

  return (
    <Popup footer={footer} header="Add a Template" id="addEmailTemplateSendGridPopup">
      <EmailTemplateSendGridForm activities={activities} emailTemplate={emailTemplate} formName="newTemplate" />
    </Popup>
  );
};

const mapStateToProps = state => ({
  emailTemplate: state.emailTemplatesSendGrid.get('newTemplate'),
  activities: state.eventActivities.getIn(['activitiesOnlyValues', 'emailTemplateActivities', 'target'], List()),
});

/** Add email template send grid popup component. */
export const AddEmailTemplateSendGridPopup = connect(mapStateToProps, {
  createEmailTemplateSendGrid,
  handleUpdateForm,
})(memo(AddEmailTemplateSendGridPopupComponent));
